export default "__VITE_ASSET__CHcKB4ls__"